import { Button, useToast } from '@chakra-ui/react'
import { useFormik } from 'formik'
import { FileUpload } from 'primereact/fileupload'
import { InputText } from 'primereact/inputtext'
import { Messages } from 'primereact/messages'
import { Tag } from 'primereact/tag'
import { classNames } from 'primereact/utils'
import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react'
import { useMutation as useMutationRQ } from 'react-query'
import CsvValidator from './utils/Components/CsvValidator'
import { uploadCSV } from './utils/uploadCSV'

const acceptedFileType =
  '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
interface IUploadCsvProps {
  toggleSideBar: Dispatch<SetStateAction<boolean>>
  showResponse: (msg: string, isError: boolean) => void
  refetch: () => void
}

const UploadCSVDrawer: React.FC<IUploadCsvProps> = (props: IUploadCsvProps) => {
  const [isValidatorOpen, setisValidatorOpen] = useState(false)
  const msgs1 = useRef<any>(null)
  const msgs2 = useRef<any>(null)
  const toast = useToast({
    position: 'top',
  })
  const { refetch, showResponse, toggleSideBar } = props

  useEffect(() => {
    // update message on component mount
    msgs1.current.show({
      severity: 'info',
      detail: 'All following columns mandatory and should be included in CSV file ',
      sticky: true,
      closable: false,
    })
    msgs2.current.show({
      severity: 'warn',
      detail: 'Columns name should not be modified ',
      sticky: true,
      closable: false,
    })
  }, [])

  // upload mutation
  const [uploadMutation, { isLoading }] = useMutationRQ(uploadCSV, {
    onSuccess: (data) => {
      toast({
        title: 'Success',
        description: 'Csv File Uploaded',
        status: 'success',
      })
      toggleSideBar(false)
      if (data.statusCode || data.message) {
        showResponse(
          (data.message && data.message.message) ||
            (typeof data.message === 'string' && data.message) ||
            data.statusCode,
          true,
        )
      } else {
        // handlesuccess
        showResponse('Leads Uploaded Successfully', false)
        toggleSideBar(false)
        refetch()
      }
    },
    onError: (er) => {
      toast({
        title: 'Error',
        description: 'File Not Uploaded',
        status: 'error',
      })
      console.error(er)
    },
  })
  const formik = useFormik<{
    token: string
    file?: File
  }>({
    initialValues: {
      token: '',
      file: undefined,
    },
    validate: (data: any) => {
      let errors: any = {}

      if (!data.token) {
        errors.token = 'Affiliate Token is required.'
      }
      return errors
    },
    onSubmit: (data) => {
      // should be affiliate link id not token
      if (data.file) {
        uploadMutation({ file: data.file, token: data.token })
      }
    },
  })
  const isFormFieldValid = (name: 'token') => !!(formik.touched[name] && formik.errors[name])
  const getFormErrorMessage = (name: 'token') => {
    return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>
  }

  return (
    <div>
      <h2>IMPORT FORM CSV</h2>
      <div className="p-grid p-justify-end">
        <Button
          onClick={() => (window.location.href = '/assets/leadsUpload.csv')}
          className="p-button-outlined p-button-info p-mb-3"
        >
          Download an example CSV file
        </Button>
      </div>
      <Messages ref={msgs1} />
      <Tag severity="danger" className="p-ml-2" value="firstName" />
      <Tag severity="danger" className="p-ml-2" value="lastName" />
      <Tag severity="danger" className="p-ml-2" value="email" />
      <Tag severity="danger" className="p-ml-2" value="phone" />
      <Tag severity="danger" className="p-ml-2" value="language" />
      <Tag severity="danger" className="p-ml-2" value="leadStatus" />
      <Tag severity="danger" className="p-ml-2" value="country" />

      <Messages ref={msgs2} />

      <form onSubmit={formik.handleSubmit} className="p-fluid">
        <div className="p-field p-mt-5">
          <span className="p-float-label">
            <InputText
              id="token"
              name="token"
              value={formik.values.token}
              onChange={formik.handleChange}
              autoFocus
              className={classNames({
                'p-invalid': isFormFieldValid('token'),
              })}
            />
            <label
              htmlFor="name"
              className={classNames({
                'p-error': isFormFieldValid('token'),
              })}
            >
              Affiliate Token
            </label>
          </span>
          {getFormErrorMessage('token')}
        </div>
        <FileUpload
          className="p-mt-4"
          name="demo[]"
          url=""
          // onUpload={onUpload}
          accept={acceptedFileType}
          multiple={false}
          maxFileSize={20000000}
          customUpload
          uploadHandler={(data) => {
            formik.setFieldValue('file', data.files[0])
            setisValidatorOpen(true)
          }}
          emptyTemplate={
            <p className="p-m-0">
              Drag and drop files to here to upload.
              <br />
              Support for csv and excel files.
            </p>
          }
        />
        <Button type="submit" isLoading={isLoading} mt={2}>
          Submit
        </Button>
      </form>
      {formik.values.file && (
        <CsvValidator
          isVisible={isValidatorOpen}
          setIsVisible={setisValidatorOpen}
          file={formik.values.file}
          onOkFn={(newFile) => {
            formik.setFieldValue('file', newFile)
            formik.submitForm()
            setisValidatorOpen(false)
          }}
        />
      )}
    </div>
  )
}

export default UploadCSVDrawer
